(ns hypnos.core
  "Hypnos UI application entry point."
  (:require ["aws-amplify" :default Amplify :as amp]
            [hypnos.datadog :as ddog]
            [hypnos.backoffice.app :as bo-app]
            [hypnos.backoffice.routes :as bo-routes]
            [hypnos.config :refer [AMPLIFY
                                   BACKOFFICE-SUBDOMAIN
                                   DME-SUBDOMAIN
                                   IRIS-SUBDOMAIN
                                   SLEEPLAB-SUBDOMAIN
                                   url-subdomain
                                   debug?]]
            [hypnos.consumer.app :as c-app]
            [hypnos.consumer.routes :as c-routes]
            [hypnos.dme.app :as dme-app]
            [hypnos.dme.routes :as dme-routes]
            [hypnos.sleeplab.app :as sl-app]
            [hypnos.sleeplab.routes :as sl-routes]
            [re-frame.core :as rf]
            [reagent.dom :as dom]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Debugging Stuff

(enable-console-print!)

(ddog/init)

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

;; (def ^{:private true} MOBILE-REGEX
;;   #"(android|bb\d+|meego|mozipf)")

(defn dev-setup []
  (when @debug?
    (enable-console-print!)
    (println "dev mode is enabled!")))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn subdomain
  "Returns the current subdomain."
  []
  (url-subdomain (.-hostname (.-location js/window))))

;; (defn- mobile?
;;   "Check if the page is rendered in a mobile (phone)?"
;;   []
;;   (let [user-agent (or (.-userAgent js/navigator)
;;                        (.-vendor js/navigator)
;;                        (.-opera js/window))
;;         identifier (str/lower-case (subs user-agent 0 4))]
;;     (re-matches MOBILE-REGEX identifier)))

(defn- admin-app?
  "IRIS administration application?"
  []
  (= IRIS-SUBDOMAIN (subdomain)))

(defn- dme-app?
  "DME application"
  []
  (or (= DME-SUBDOMAIN (subdomain))
      (= BACKOFFICE-SUBDOMAIN (subdomain)))) ;; remove once transition is done

(defn- sleeplab-app?
  "SleepLab application"
  []
  (= SLEEPLAB-SUBDOMAIN (subdomain)))

(defn- determine-app
  "Determine the app"
  []
  (cond
    (admin-app?)    [bo-app/app]
    (dme-app?)      [dme-app/app]
    (sleeplab-app?) [sl-app/app]
    :else           [c-app/app]))

(defn ^:dev/after-load mount-root
  []
  (let [app (determine-app)]
    (rf/clear-subscription-cache!)
    (.configure Amplify (clj->js @AMPLIFY))
    (dom/render app (.getElementById js/document "app"))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn ^:export init
  []
  (js/console.log "Starting application ...")
  (cond
    (admin-app?)    (do
                      (bo-routes/app-routes)
                      (rf/dispatch-sync [:backoffice/initialize-app])
                      (rf/dispatch-sync [:amplify/init]))
    (dme-app?)      (do
                      (dme-routes/app-routes)
                      (rf/dispatch-sync [:dme/initialize-app])
                      (rf/dispatch-sync [:amplify/init]))
    (sleeplab-app?) (do
                      (sl-routes/app-routes)
                      (rf/dispatch-sync [:sleeplab/initialize-app])
                      (rf/dispatch-sync [:amplify/init]))
    :else           (do
                      (c-routes/app-routes)
                      (rf/dispatch-sync [:consumer/initialize-app (subdomain)])))
  (dev-setup)
  (mount-root))
